import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { grey } from './colors';
import { buildPaletteFromMetadata, type Token } from './panw-palette/token-metadata';

const textTokens = (mode: PaletteMode): Token[] => [
  { propertyPath: 'disabled', tokenName: '--semantic-text-disabled' },
  { propertyPath: 'info', tokenName: '--semantic-text-info' },
  { propertyPath: 'primary', tokenName: '--semantic-text-default' },
  { propertyPath: 'secondary', tokenName: '--text-secondary' },
  { propertyPath: 'placeholder', tokenName: '--semantic-text-placeholder' },
  { propertyPath: 'selected', tokenName: '--semantic-text-selected' },
  { propertyPath: 'link', tokenName: '--semantic-text-link' },
  { propertyPath: 'linkHover', tokenName: '--semantic-text-link-hover' },
  // once we flip the feature flag, we can clean references to these colors up
  // legacySecondary -> primary post flag flip
  { propertyPath: 'legacySecondary', tokenName: '--semantic-text-default' },
  {
    propertyPath: 'inversePrimary',
    tokenName: '--semantic-text-inverse',
  },
  {
    propertyPath: 'navigationHeader',
    tokenName: mode === 'light' ? '--semantic-text-inverse' : '--semantic-text-default',
  },
  { propertyPath: 'accent', tokenName: '--semantic-text-default' },
  { propertyPath: 'warning', tokenName: '--semantic-text-warning' },
];

export const textTokenMetadata = {
  componentName: 'text',
  tokens: textTokens,
};

export const text = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['text'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata<PaletteOptions['text']>(textTokens(mode), tokens, xcorTokens);
  }

  const accent = grey[300];
  return mode === 'light'
    ? {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        selected: '#FF00FF',
        info: '#FF00FF',
        link: '#FF00FF',
        linkHover: '#FF00FF',
        warning: '#FF00FF',
        // ^^^
        primary: grey[950],
        secondary: grey[600],
        legacySecondary: grey[600],
        placeholder: grey[600],
        disabled: grey[300],
        inversePrimary: grey[50],
        navigationHeader: grey[200],
        accent,
      }
    : {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        selected: '#FF00FF',
        info: '#FF00FF',
        link: '#FF00FF',
        linkHover: '#FF00FF',
        warning: '#FF00FF',
        // ^^^
        primary: grey[50],
        secondary: grey[200],
        legacySecondary: grey[200],
        placeholder: grey[200],
        disabled: grey[500],
        inversePrimary: grey[950],
        navigationHeader: grey[200],
        accent,
      };
};
